import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.hotClub}/rest/v3`, {
  get: {
    'membership.data': '/membership',
    'membership.helpContent': '/membership/help',
    'membership.producer': '/membership/producer/info'
  }
});

Request.register(`${Settings.api.content}/v4/memberships`, {
  get: {
    'addon.cost': '/addOn/streaming/cost'
  },
  put: {
    'addon.activate': '/addOn/streaming'
  }
});
